// Duration for continuous feed button press in milliseconds
export const CONTINUOUS_FEED_BUTTON_PRESS_DURATION = 1500;
